import { createApiClient } from '../../shared/http/createApiClient.js';

const client = createApiClient({ auth: true });

export const replicateApi = {
  getStatus: () => client.get('/sql-tool/replicate/status'),
  listTables: () => client.get('/sql-tool/replicate/tables'),
  run: (tables, copySchema, copyData) =>
    client.post('/sql-tool/replicate', { tables, copy_schema: copySchema, copy_data: copyData }),
};
